// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__GJkYf","gfeWrapper":"CalendarEvent_gfeWrapper__13Khr"};